import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminHotelsService {

  serviceBaseUrl: string = '';

  constructor(private http: HttpClient) {
    this.serviceBaseUrl = environment.serviceBaseUrl;
  }

  getHotels(): Promise<any> {
    return this.http.get(this.serviceBaseUrl + "Kesavi/HotelGet").toPromise();
  }

  addHotels(hotelsObj): Promise<any> {
    return this.http.post(this.serviceBaseUrl + "Kesavi/HotelInsert", hotelsObj).toPromise();
  }

  editHotels(hotelsObj): Promise<any> {
    return this.http.post(this.serviceBaseUrl + "Kesavi/HotelInsert", hotelsObj).toPromise();
  }

  deleteHotelsByID(ID): Promise<any> {
    return this.http.get(this.serviceBaseUrl + "Kesavi/HotelDelete/" + ID).toPromise();
  }

}
